import React, { useState } from "react";
import QRGenerateButton from "./QRGenerateButton";

function WhatsappQR() {
  const [input, setInput] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formError, setFormError] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [whatsappMessage, setWhatsappMessage] = useState("");

  function createWhatsApp() {
    if (whatsappNumber) {
      var QRWhatsApp =
        "https://wa.me/" +
        whatsappNumber +
        "?text=" +
        encodeURIComponent(whatsappMessage);
      setInput(QRWhatsApp);
      showQRCode();
      setShowQR(true);
      setFormError(false);
    } else {
      setShowQR(false);
      setFormError(true);
    }
  }

  function showQRCode() {
    document.getElementById("qrwrap").scrollIntoView({
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="qr-form">
        <h3>WhatsApp QR Code</h3>
        <p>
          Using whatsApp? Let your customers reach you faster with a customized
          QR.
        </p>
        <input
          type="text"
          value={whatsappNumber}
          onInput={(e) => setWhatsappNumber(e.target.value)}
          name="qrcode_whatsapp"
          id="qrwhatsapp"
          placeholder="Enter whatsapp number including countrycode, no + sign needed"
        />
        <textarea
          value={whatsappMessage}
          onInput={(e) => setWhatsappMessage(e.target.value)}
          name="qrcode_whatsapp_msg"
          id="qrwhatsapp_msg"
          placeholder="Enter a message"
          maxLength={160}
        />
        <p>
          Make sure the entered phone number already has a WhatsApp account on
          it!
        </p>
        {formError && (
          <div className="errorMessage">Error: Field cannot be blank!</div>
        )}
        <button
          type="button"
          className="contrast"
          onClick={() => {
            createWhatsApp();
          }}
        >
          Generate QR
        </button>
      </div>
      <QRGenerateButton
        QRType="whatsapp"
        QRValue={input}
        showQR={showQR}
        setInput={setInput}
        setShowQR={setShowQR}
      />
    </>
  );
}

export default WhatsappQR;
